/* Imports */
import React from "react"
import { Flexbox, ButtonIcon } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

import commonProps from "../../data/common-props"

const ButtonIconPage = () => {
    const items = [
        {
            title: "Plain",
            content: (
                <Flexbox gap="s" wrap="wrap">
                    <ButtonIcon buttonStyle="plain" color="primary" icon="mail-solid" />

                    <ButtonIcon buttonStyle="plain" color="secondary" icon="mail-solid" />

                    <ButtonIcon buttonStyle="plain" color="success" icon="mail-solid" />

                    <ButtonIcon buttonStyle="plain" color="danger" icon="mail-solid" />

                    <ButtonIcon buttonStyle="plain" color="warning" icon="mail-solid" />

                    <ButtonIcon buttonStyle="plain" color="white" icon="mail-solid" />

                    <ButtonIcon buttonStyle="plain" color="primary" icon="mail-solid" disabled />
                </Flexbox>
            ),
            code: '<ButtonIcon\n    buttonStyle="plain"\n    color="primary"\n    icon="mail-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="plain"\n    color="secondary"\n    icon="mail-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="plain"\n    color="success"\n    icon="mail-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="plain"\n    color="danger"\n    icon="mail-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="plain"\n    color="warning"\n    icon="mail-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="plain"\n    color="white"\n    icon="mail-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="plain"\n    color="primary"\n    icon="mail-solid"\n    disabled\n/>',
        },
        {
            title: "Transparent",
            content: (
                <Flexbox gap="s" wrap="wrap">
                    <ButtonIcon buttonStyle="transparent" color="primary" fajnyIcon="heart-solid" />

                    <ButtonIcon buttonStyle="transparent" color="secondary" fajnyIcon="heart-solid" />

                    <ButtonIcon buttonStyle="transparent" color="success" fajnyIcon="heart-solid" />

                    <ButtonIcon buttonStyle="transparent" color="danger" fajnyIcon="heart-solid" />

                    <ButtonIcon buttonStyle="transparent" color="warning" fajnyIcon="heart-solid" />

                    <ButtonIcon buttonStyle="transparent" color="white" fajnyIcon="heart-solid" />

                    <ButtonIcon buttonStyle="transparent" color="primary" fajnyIcon="heart-solid" disabled />
                </Flexbox>
            ),
            code: '<ButtonIcon\n    buttonStyle="transparent"\n    color="primary"\n    fajnyIcon="heart-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="transparent"\n    color="secondary"\n    fajnyIcon="heart-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="transparent"\n    color="success"\n    fajnyIcon="heart-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="transparent"\n    color="danger"\n    fajnyIcon="heart-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="transparent"\n    color="warning"\n    fajnyIcon="heart-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="transparent"\n    color="white"\n    fajnyIcon="heart-solid"\n/>\n\n<ButtonIcon\n    buttonStyle="transparent"\n    color="primary"\n    fajnyIcon="heart-solid"\n    disabled\n/>',
        },
        {
            title: "Loading",
            content: <ButtonIcon buttonStyle="plain" color="primary" icon="mail-solid" isLoading />,
            code: '<ButtonIcon buttonStyle="plain" color="primary" icon="mail-solid" isLoading />',
        },
    ]

    const propsItems = [
        {
            name: "icon",
            type: "String",
            example: "mail",
            required: "Yes, if you want to use your own icon",
        },
        {
            name: "fajnyIcon",
            type: "String",
            example: "mail-solid",
            possible: commonProps.fajnyIcons,
            required: commonProps.requiredFajnyIcon,
        },
        {
            name: "buttonStyle",
            type: "String",
            example: "transparent",
            possible: '"plain" | "transparent"',
            default: "plain",
        },
        {
            name: "color",
            type: "String",
            example: "warning",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            name: "isLoading",
            type: "Boolean",
        },
        {
            name: "to",
            type: "String",
            example: "/contact",
            required: (
                <>
                    If you want to use this component as a{" "}
                    <code>&lt;Link&gt;</code>
                </>
            ),
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default ButtonIconPage
